import { render, staticRenderFns } from "./duoVideoTileView.vue?vue&type=template&id=4488b5c2&scoped=true&"
import script from "./duoVideoTileView.vue?vue&type=script&lang=js&"
export * from "./duoVideoTileView.vue?vue&type=script&lang=js&"
import style0 from "./duoVideoTileView.vue?vue&type=style&index=0&id=4488b5c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4488b5c2",
  null
  
)

export default component.exports